export default __webpack_public_path__ + "static/media/YE.cc2cab65.svg";